import { render, staticRenderFns } from "./InfoView_TermsAndConditions.vue?vue&type=template&id=548b29a9&"
import script from "./InfoView_TermsAndConditions.vue?vue&type=script&lang=js&"
export * from "./InfoView_TermsAndConditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports